<adapt-toolbar-content alignment="right"
                       [ordinal]="9999">
    <button adaptButton="return"
            class="ms-2 active"
            (click)="return()"
            data-tour="return-to-path-button">
        {{ buttonText }}
    </button>
</adapt-toolbar-content>
